<template>
  <v-row no-gutters class="tag-item__row" align="center">
    <v-col cols="auto" v-for="(item, index) in itemsTag" :key="index">
      <div
        class="tag-item__tag"
        :class="isClick ? 'tag-item__tag--clickable' : ''"
        :tabindex="isClick ? 0 : undefined"
        @click="redirectTag(item.id)"
      >
        <p class="mb-0 label d-inline-flex" :class="colorTag">
          {{ item.tag || item.name || item.companyName || item.label }}
        </p>
        <SvgIcon
          name="remove"
          class="pl-1 tag-item__close-button"
          v-if="canRemove"
          @click="$emit('remove', item)"
        />
      </div>
    </v-col>
    <slot />
  </v-row>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class TagItem extends Vue {
  @Prop(Array) itemsTag: any;
  @Prop({ default: false }) isClick: boolean;
  @Prop({ default: "black" }) color: string;
  @Prop({ default: false }) canRemove: boolean;
  get colorTag(): string {
    return `${this.color}--text`;
  }
  redirectTag(id: number): void {
    if (!this.isClick) return;
    if (this.$route.name === "searchTagId") {
      this.$router.replace({ name: "searchTagId", params: { id: `${id}` } });
      this.$emit("reload");
    } else {
      this.$router.push({ name: "searchTagId", params: { id: `${id}` } });
    }
  }
}
</script>
<style lang="sass">
$body-font-family: 'Open Sans'
.tag-item__
  &row
    gap: 8px
  &tag
    display: flex
    align-items: center
    justify-content: center
    background: var(--v-grayTransmission-base) !important
    border-radius: 16px
    height: 27px
    padding: 5px 8px
    gap: 16px
    border: 1px solid transparent
    transition: background 0.5s ease, box-shadow 0.5s ease, border-color 0.5s ease
    &--clickable
      cursor: pointer
      outline: none
      &:hover
        background: var(--v-gray50-base) !important
      &:active
        background: var(--v-gray50-base) !important
        box-shadow: 0 2px 4px 0 var(--v-gray90-base) inset
      &:focus-visible
        border-color: var(--v-tealFocus-base)
        background: var(--v-grayTransmission-base) !important
  &close-button
    cursor: pointer !important
</style>
